/**
 * Single source of truth for the "chart content top" CSS expression.
 *
 * Composition (matches the sticky stack rendered by the Shell):
 *   64px                          Shell header (`<header>` in Shell.tsx)
 * + var(--recent-bar-height, 0px) <RecentPatientsBar> (published while it
 *                                 has at least one pill to render; 0 when
 *                                 the bar is unmounted)
 * + var(--patient-header-height,  <PatientChartActionBar> (published while
 *     0px)                        the chart is mounted; falls back to 0 on
 *                                 non-chart routes so a stale fallback
 *                                 never leaves the chart area too short)
 *
 * Consumed by:
 *   - `<PatientPage>` chart sidebar (`top` + `height`) + scroll container
 *     height + ScrollContext.Provider `stickyTop`
 *   - `<CallPage>` chart sidebar (`top` + `height`) + right-pane
 *     scroll-container height
 *   - `<ZoomPanel>` outer `<aside>` (`top` + `height`)
 *
 * Read it as `top: var(--chart-content-top, 64px)` if you prefer a fallback;
 * the existing consumers compose the expression directly so a missing
 * `<PatientChartActionBar>` cleanly collapses to "64px + recent-bar".
 *
 * If the math ever needs to change (taller header, additional sticky row),
 * update this constant and every consumer reflows automatically.
 */
export const CHART_CONTENT_TOP_VAR =
  'calc(64px + var(--recent-bar-height, 0px) + var(--patient-header-height, 0px))'

/**
 * Convenience: the equivalent expression for "remaining viewport below the
 * sticky stack" — used for the chart sidebar / scroll-container heights.
 */
export const CHART_CONTENT_HEIGHT_VAR = `calc(100vh - ${CHART_CONTENT_TOP_VAR})`
